import { Text } from "@/components";

export const HowItWorks = () => {
  return (
    <div className="bg-black py-16">
      <div className="container mx-auto">
        <Text.Heading className="text-white text-center">
          How it works
        </Text.Heading>

        <div className="text-center text-lg mt-6">Step-by-Step Process</div>

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6 mt-8 xl:mt-16">
          {[
            {
              title: "Consultation",
              description: "Discuss your needs with our experts.",
            },
            {
              title: "Share Data",
              description:
                "Email, data room... however you want to get it to us.",
            },
            {
              title: "Concierge Onboarding",
              description: "Don’t lift a finger, we’ll get you all set up",
            },
            {
              title: "Ongoing Management",
              description:
                "A few keystrokes over email is all you need moving forward",
            },
          ].map(({ title, description }, idx) => (
            <div
              className="flex flex-col gap-4 px-6 py-8 bg-active rounded border-b-4 border-secondary"
              key={idx}
            >
              <div className="text-2xl md:text-4xl text-secondary">Step {idx + 1}</div>
              <div className="text-white text-sm md:text-xl font-medium">{title}</div>
              <div className="text-xl md:text-2xl">{description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
